import { api } from './client'

/**
 * Dashboard service — wraps cb-api's /dashboards/* endpoints, which bridge the
 * legacy HomePage/FormLayout WCF (spec 038). Read-only in this slice.
 */
const dashboardService = {
  /** GET /dashboards — the user's dashboard catalog. */
  async list() {
    const res = await api.get('/dashboards')
    return res?.data?.dashboards || []
  },

  /** GET /dashboards/:id — one dashboard's widgets (+ grid coords). */
  async get(id) {
    const res = await api.get(`/dashboards/${id}`)
    return res?.data || null
  },

  /** GET /dashboards/chart/:chartId/data — chart-ready { rows, kind, valueKey, … } for ReportChart. */
  async chartData(chartId) {
    const res = await api.get(`/dashboards/chart/${encodeURIComponent(chartId)}/data`)
    return res?.data || null
  },

  /** GET /dashboards/formula/:id — a KPI tile's { name, value, format } (SystemFormula). */
  async formula(id) {
    const res = await api.get(`/dashboards/formula/${id}`)
    return res?.data || null
  },

  /** GET /dashboards/production-origination — the P&O summary tile. */
  async productionOrigination(range = 'ytd') {
    const res = await api.get('/dashboards/production-origination', { range })
    return res?.data || null
  },

  /** GET /dashboards/activities?kind=tasks|appointments — today's items list. */
  async activities(kind) {
    const res = await api.get('/dashboards/activities', { kind })
    return res?.data?.items || []
  },

  /** POST /dashboards/ai-summary — grounded plain-language summary of the dashboard's
   *  resolved widget data. payload: { name, metrics[{label,value,format,description}],
   *  charts[{name,rowCount,total,top}], productionOrigination, tasksCount, tasksTitles,
   *  appointmentsCount, appointmentsTitles }. */
  async aiSummary(payload) {
    const res = await api.post('/dashboards/ai-summary', payload)
    return res?.data?.summary || ''
  },
}

export default dashboardService
